import React, { useEffect, useState } from 'react';
import { classnames } from 'tailwindcss-classnames';
import SvgIcon from '../SvgIcon/SvgIcon';
import { pageNavigationDataLayerPush, menuLocation } from 'lib/util/gtm-datalayer';

const BackToTopButton = () => {
  const [showButton, setShowButton] = useState(false);

  const handleScroll = () => {
    const body = document.body;
    const html = document.documentElement;

    const height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    if (height > window.innerHeight * 4) {
      if (window.pageYOffset > 200) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    } else {
      setShowButton(false);
    }
  };

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    pageNavigationDataLayerPush('Back to Top', menuLocation[4]);
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {showButton && (
        <button
          type="button"
          className={classnames(
            'fixed',
            'bottom-4',
            'right-4',
            'z-10',
            'rounded-full',
            'border',
            'bg-white',
            'py-2',
            'px-4',
            'font-bold',
            'text-blue'
          )}
          onClick={handleClick}
        >
          <div className={classnames('flex', 'pl-1')}>
            <SvgIcon icon="arrow-up" viewBoxSize="0 0 48 48" size="em" />
          </div>
          Top
        </button>
      )}
    </>
  );
};

export default BackToTopButton;
